import { render, staticRenderFns } from "./PurchasingTypeList.vue?vue&type=template&id=9704fb5e&"
import script from "./PurchasingTypeList.vue?vue&type=script&lang=js&"
export * from "./PurchasingTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports